module.exports = __webpack_public_path__ + "img/designer.7444bb0e.png";